import { Toast } from 'react-bootstrap';

export const NoNotificationItem = () => {
  return (
    <div className={`notification-item-container`}>
      <Toast.Body className="notification-item">
        <span className={`notification-title text-black`}>
          There are no notifications at this time
        </span>
      </Toast.Body>
    </div>
  );
};
